<div class="flex flex-col gap-2">
  @if (subtitle) {
    <h2 chapterSubtitle>
      {{ subtitle }}
      @if (badge) {
        <sb-badge [color]="'brandInverted'">{{ badge }}</sb-badge>
      }
    </h2>
  }
  <h1 chapterTitle>{{ title }}</h1>
</div>

<ng-content></ng-content>
<div class="mt-2 flex gap-2 self-start max-xl:flex-wrap">
  <button
    class="max-xl:w-full"
    sb-button
    [color]="'primary'"
    [size]="'lg'"
    (click)="next.emit()"
    [sbLadda]="nextButtonLoading"
    [disabled]="skipButtonLoading || nextButtonDisabled"
  >
    {{ nextButtonLabel }}
  </button>
  @if (showSkipButton) {
    <button
      class="max-xl:w-full"
      sb-button
      [color]="skipButtonTheme"
      [size]="'lg'"
      (click)="skip.emit()"
      [sbLadda]="skipButtonLoading"
      [disabled]="nextButtonLoading || skipButtonDisabled"
    >
      {{ skipButtonLabel }}
      @if (skipButtonIcon) {
        <sb-icon iconPositionEnd [name]="skipButtonIcon" [size]="'lg'" />
      }
    </button>
  }
</div>
